import { Header } from "@artprov/design-system";
import { useComprasAuth } from "../../hooks/useComprasAuth.js";
import { useFiltersStore } from "../../zustand/filters.store.js";
import { useTablaStore } from "../../zustand/tabla.store.js";

export default function NavBar() {
    const { logout } = useComprasAuth();
    const resetToDefault = useFiltersStore((state) => state.resetToDefault);
    const resetTablaState = useTablaStore((state) => state.resetTablaState);

    const opcionesDelMenu = [
        { icon: 'person', opcion: 'Mi información' },
        { icon: 'settings', opción: 'Configuración' },
        {
            icon: "power_settings_new",
            opcion: "Cerrar sesión",
            onClick: () => {
                resetToDefault();
                resetTablaState();
                logout({ redirectUri: window.location.origin });
            },
        },
    ]

    return (
        <Header
            className="justify-center"
            classNameContainerOpciones={"min-w-60"}
            opcionesDelMenu={opcionesDelMenu}
        />
    );
}
